import { render, staticRenderFns } from "./Scene12.vue?vue&type=template&id=80922d44&scoped=true"
import script from "./Scene12.vue?vue&type=script&lang=js"
export * from "./Scene12.vue?vue&type=script&lang=js"
import style0 from "./Scene12.vue?vue&type=style&index=0&id=80922d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80922d44",
  null
  
)

export default component.exports